<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/JLPNsp/tc-custom/9781638490548.jpg?1706992485621" alt="This image is the cover for the book Resonant Vol. 1, Resonant"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Resonant Vol. 1, Resonant
      </h1>
      <p class="bookDescription body article font2">
        <p>A decade ago the first Waves unleashed humanity's worst impulses and the world plunged into chaos. Now single father Paxton can resist the waves, and he's created an oasis of peace for his children. But he must venture out to save his son. OUR WORST IMPULSES UNLEASHED. A decade has passed since the first Waves hit, unleashing humanity’s darkest impulses and plunging the world into chaos. Paxton, a single father of three, must venture from the secluded haven they’ve built to restock the medicine his chronically-ill youngest son needs to survive. When the somewhat routine trip goes awry, Paxton and his children—now separated—will battle everything in their path to reunite. Collects issues #1 to #5 of the ten issue series.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David Andry, Skylar  Patridge, Deron Bennett, Jason Wordie
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Vault Comics
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?260038e1